import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import ProfileImage from '../ProfileImage';
import VipIcon from '../../Icons/VipIcons';

/**
 * MiniUserCard - A minimal inline user display (for mentions, tags, etc.)
 */

const CardContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px 4px 4px;
  background: ${({ theme }) => theme.colors.bg2};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 20px;
  cursor: ${({ $clickable }) => $clickable ? 'pointer' : 'default'};
  transition: all 0.2s ease;

  ${({ $clickable, theme }) => $clickable && `
    &:hover {
      background: ${theme.colors.primaryGradientLight};
      border-color: ${theme.colors.primaryPink}40;
    }
  `}
`;

const NameText = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text};
  white-space: nowrap;
`;

const VerifiedBadge = styled.span`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.primaryPink};
`;

const MiniUserCard = ({
  user,
  showVerified = true,
  clickable = true,
  onClick,
  className,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!clickable) return;
    
    if (onClick) {
      onClick(user);
    } else {
      navigate(`/${user.username}`);
    }
  };

  return (
    <CardContainer 
      onClick={handleClick} 
      $clickable={clickable}
      className={className}
    >
      <ProfileImage user={user} size="24px" />
      <NameText>{user.fullName || user.username}</NameText>
      {showVerified && user.verified && (
        <VerifiedBadge>
          <VipIcon name="VerifiedBadge" size={12} />
        </VerifiedBadge>
      )}
    </CardContainer>
  );
};

export default MiniUserCard;
